'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { fetchApplicationVersion } from '@/applicationVersionService';

const initDataDogRum = async () => {
  // check for undefined here to ensure we do not send events
  // with titles like `login-ui-next-undefined` to datadog
  const env = process.env.NEXT_PUBLIC_ENV_NAME;
  if (!env || env === 'dev') return;

  // `version` is optional to Datadog, so a failed version request must not keep RUM off.
  const version = await fetchApplicationVersion().catch(() => undefined);

  // Guarded after the await, not before it. With reactStrictMode on, the effect runs twice
  // before the first version request resolves, so a check ahead of the fetch would let both
  // runs reach init() and trip the SDK's "DD_RUM is already initialized" error. init() records
  // its configuration synchronously, so whichever request resolves second stops here. Checking
  // window.DD_RUM does not work for this: the SDK assigns that global at import time.
  if (datadogRum.getInitConfiguration()) return;

  datadogRum.init({
    applicationId: 'dd13c625-d114-49c1-9116-1976155285bc',
    clientToken: 'pub1f3c3d443664d46566c976befa7e3bb2',
    site: 'datadoghq.com',
    service: `login-ui-next-${env}`,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [
      'https://api.nyshex.com',
      /^https:\/\/api\.(staging|salesdemo)\.nyshex\.com/,
      (url) => url.startsWith('https://api.nyshex.com'),
    ],
    defaultPrivacyLevel: 'mask-user-input',
  });
};

const InitRum = () => {
  useEffect(() => {
    initDataDogRum();
  }, []);

  return null;
};

export default InitRum;
